exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".order-list-wrap[data-v-071664a0]{height:100%;overflow:scroll}.order-list-wrap .no-order[data-v-071664a0]{text-align:center;margin-top:10px}.order-list-wrap .order-card-wrap[data-v-071664a0]{margin:12px 10px}", ""]);
